import { Link } from 'wouter';
import type { StoreReviewWorkload } from '@shared/review-workload';
import { storeReviewAge } from '@/lib/storeReviewPriority';

export function StoreReviewMarker({ workload, now, href }: {
  workload?: StoreReviewWorkload; now: number; href: string;
}) {
  if (!workload?.pendingCount) return null;
  return <div className="mt-2 border-l-2 border-teal-600 pl-2" onKeyDown={event => event.stopPropagation()}>
    <div className="flex flex-wrap items-center gap-2">
      <span className="rounded border border-teal-200 bg-teal-50 px-1.5 py-0.5 text-xs font-medium text-teal-800">
        {workload.pendingCount} awaiting review
      </span>
      <Link href={href} className="text-xs text-teal-800 underline underline-offset-2"
        onClick={event => event.stopPropagation()} aria-label={`Review jobs for ${workload.storeName}`}>
        Review jobs
      </Link>
    </div>
    <div className="mt-1 text-xs text-muted-foreground">
      {storeReviewAge(workload, now)}
      {workload.unknownAgeCount > 0 && <span> · {workload.unknownAgeCount} age{workload.unknownAgeCount === 1 ? '' : 's'} unknown</span>}
    </div>
  </div>;
}
